import { Link } from 'react-router-dom';
import { brand } from '@/mocks/gossip';

const columnLinks = [
  {
    title: '逛内容',
    links: [
      { to: '/', label: '首页' },
      { to: '/topics', label: '吃瓜热榜' },
      { to: '/faq', label: '常见问题' },
    ],
  },
  {
    title: '玩互动',
    links: [
      { to: '/activities', label: '转发抽奖' },
      { to: '/activities', label: '评论区打卡' },
      { to: '/activities', label: '粉丝投票' },
    ],
  },
  {
    title: '关于',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/about', label: '内容原则' },
      { to: '/about', label: '联系方式' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-100 border-t border-primary-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg">
                <i className="ri-emotion-happy-line"></i>
              </span>
              <span className="font-heading text-xl text-primary-900">{brand.name}</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed max-w-xs">
              {brand.slogan}。聚合每日热点话题，解锁转发抽奖、评论区打卡与粉丝投票玩法。
            </p>
            <p className="mt-4 text-sm text-foreground-600">
              <i className="ri-mail-line mr-1"></i>
              {brand.email}
            </p>
          </div>

          {columnLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-primary-900 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} {brand.name}. 内容仅供娱乐讨论，互动结果以站内公示为准。
          </p>
          <p className="text-xs text-foreground-600">
            服务时间：{brand.serviceTime}
          </p>
        </div>
      </div>
    </footer>
  );
}